import { render, staticRenderFns } from "./PreClosingMeetingThisYear.vue?vue&type=template&id=06968fc4&scoped=true&"
import script from "./PreClosingMeetingThisYear.vue?vue&type=script&lang=ts&"
export * from "./PreClosingMeetingThisYear.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06968fc4",
  null
  
)

export default component.exports